import React from "react";
import { Sliders, List, Settings } from "react-feather";
import { Business, Description, ReceiptLong, WebStories } from '@mui/icons-material';

import async from "../Components/Async";


const Login = async(() => import("./../pages/Login"));
const ForgotPassword = async(() => import("./../pages/ForgotPassword"));
const ResetPassword = async(() => import("./../pages/ResetPassword"));
const Dashboard = async(() => import("./../pages/Dashboard"));
const Setting = async(() => import("./../pages/Settings"));

const InsuranceCompanyList = async(() => import("./../pages/InsuranceCompany/InsuranceCompanyList"));
const InsuranceCompanyShow = async(() => import("./../pages/InsuranceCompany/InsuranceCompanyShow"));
const InsuranceCompanyCreate = async(() => import("./../pages/InsuranceCompany/InsuranceCompanyCreate"));
const InsuranceCompanyUpdate = async(() => import("./../pages/InsuranceCompany/InsuranceCompanyUpdate"));
const InsuranceCompanyUpdateEmail = async(() => import("./../pages/InsuranceCompany/InsuranceCompanyUpdateEmail"));
const InsuranceCompanyChangePassword = async(() => import("./../pages/InsuranceCompany/InsuranceCompanyChangePassword"));
const InsuranceCompanyAssignPlanShowTnC = async(() => import("./../pages/InsuranceCompany/InsuranceCompanyAssignPlanShowTnc"));

const PlanList = async(() => import("./../pages/Plan/PlanList"));
const PlanCreate = async(() => import("./../pages/Plan/PlanCreate"));
const PlanShow = async(() => import("./../pages/Plan/PlanShow"));
const PlanUpdate = async(() => import("./../pages/Plan/PlanUpdate"));
const PlanDynamicCreate = async(() => import("./../pages/Plan/PlanDynamicCreate"));
const PlanDynamicUpdate = async(() => import("./../pages/Plan/PlanDynamicUpdate"));

const PlanCreateForSpecificInsurance = async(() => import("./../pages/Plan/PlanCreateForSpecificInsurance"));
const PlanDynamicCreateForSpecificInsurance = async(() => import("./../pages/Plan/PlanDynamicCreateForSpecificInsurance"));
const PlanShowForSpecificInsurance = async(() => import("./../pages/Plan/PlanShowForSpecificInsurance"));
const PlanDynamicUpdateForSpecificInsurance = async(() => import("./../pages/Plan/PlanDynamicUpdateForSpecificInsurance"));
const PlanUpdateForSpecificInsurance = async(() => import("./../pages/Plan/PlanUpdateForSpecificInsurance"));

const PoliciesList = async(() => import("./../pages/Policies/ListPolicies"))
const PoliciesShow = async(() => import("./../pages/Policies/ShowPolicy"))


const Report = async(() => import("./../pages/reports"));

const loginRoute = {
    id: "Login",
    path: "/login",
    component: Login,
    children: null
}

const forgotPasswordRoute = {
    id: "ForgotPassword",
    path: "/forgot-password",
    component: ForgotPassword,
    children: null
}

const resetPasswordRoute = {
    id: "ResetPassword",
    path: "/reset-password/:code",
    component: ResetPassword,
    children: null
}

const dashboardsRoutes = {
    id: "Dashboard",
    path: "/dashboard",
    header: "",
    icon: <Sliders />,
    containsHome: true,
    component: Dashboard
};

const settingsRoute = {
    id: "Settings",
    path: "/settings",
    icon: <Settings />,
    component: Setting
}

const insuranceCompaniesRoutes = {
    id: "Insurance Companies",
    path: "/insurance-companies",
    icon: < Business />,
    component: InsuranceCompanyList
}

const insuranceCompanyShowRoute = {
    id: "Insurance Companies",
    path: "/insurance-companies/show/:id",
    component: InsuranceCompanyShow
}

const insuranceCompanyCreateRoute = {
    id: "Insurance Companies",
    path: "/insurance-companies/create",
    component: InsuranceCompanyCreate
}

const insuranceCompanyUpdateRoute = {
    id: "Insurance Companies",
    path: "/insurance-companies/edit/:id",
    component: InsuranceCompanyUpdate
}

const insuranceCompanyUpdateEmailRoute = {
    id: "Insurance Companies",
    path: "/insurance-companies/edit-email/:id",
    component: InsuranceCompanyUpdateEmail
}

const insuranceCompanyChangePasswordRoute = {
    id: "Insurance Companies",
    path: "/insurance-companies/change-password/:id",
    component: InsuranceCompanyChangePassword
}

const insuranceCompanyAssignPlanShowTncRoute = {
    id: "Insurance Companies",
    path: "/insurance-companies/:id/assign-plan/:assign_plan_id/show/terms-and-conditions",
    component: InsuranceCompanyAssignPlanShowTnC
}

const plansRoutes = {
    id: "Plans",
    path: "/plans",
    icon: <WebStories />,
    component: PlanList
}

const planCreateRoute = {
    id: "Plans",
    path: "/plans/create",
    component: PlanCreate
}

const planShowRoute = {
    id: "Plans",
    path: "/plans/show/:id",
    component: PlanShow
}

const planUpdateRoute = {
    id: "Plans",
    path: "plans/edit/:id",
    component: PlanUpdate
}

const planDynamicCreateRoute = {
    id: "Plans",
    path: "/plans/dynamic-create",
    component: PlanDynamicCreate
}

const planDynamicUpdateRoute = {
    id: "Plans",
    path: "/plans/dynamic-edit/:id",
    component: PlanDynamicUpdate
}

const planCreateForSpecificInsuranceRoute = {
    id: "PlansSpecific",
    path: "/insurance-companies/plans/create-specific/:id",
    component: PlanCreateForSpecificInsurance
}

const planDynamicCreateForSpecificInsuranceRoute = {
    id: "PlansSpecific",
    path: "/insurance-companies/plans/dynamic-specific/:id",
    component: PlanDynamicCreateForSpecificInsurance
}

const planShowForSpecificInsuranceRoute = {
    id: "PlansSpecific",
    path: "/insurance-companies/:insurance_id/plans/show-specific/:id",
    component: PlanShowForSpecificInsurance
}

const planDynamicUpdateForSpecificInsuranceRoute = {
    id: "PlansSpecific",
    path: "/insurance-companies/:insurance_id/plans-dynamic/update-specific/:id",
    component: PlanDynamicUpdateForSpecificInsurance
}

const planUpdateForSpecificInsuranceRoute = {
    id: "PlanSpecific",
    path: "/insurance-companies/:insurance_id/plans/update-specific/:id",
    component: PlanUpdateForSpecificInsurance
}

const policiesRoutes = {
    id: "Policies",
    path: "/policies",
    icon: <Description />,
    component: PoliciesList
}
const policyShowRoute = {
    id: "Policies",
    path: "/policies/show/:id",
    component: PoliciesShow
}

const reportRoutes = {
    id: "Report",
    path: "/report",
    icon: <ReceiptLong />,
    component: Report
}

export const dashboard = [
    dashboardsRoutes,
    settingsRoute,
    insuranceCompaniesRoutes,
    insuranceCompanyShowRoute,
    insuranceCompanyCreateRoute,
    insuranceCompanyUpdateRoute,
    insuranceCompanyUpdateEmailRoute,
    insuranceCompanyChangePasswordRoute,
    insuranceCompanyAssignPlanShowTncRoute,
    plansRoutes,
    planCreateRoute,
    planShowRoute,
    planUpdateRoute,
    planDynamicCreateRoute,
    planDynamicUpdateRoute,
    planCreateForSpecificInsuranceRoute,
    planDynamicCreateForSpecificInsuranceRoute,
    planShowForSpecificInsuranceRoute,
    planDynamicUpdateForSpecificInsuranceRoute,
    planUpdateForSpecificInsuranceRoute,
    policiesRoutes,
    policyShowRoute,
    reportRoutes,
]
export const auth = [];

export const unAuthRoutes = [loginRoute, forgotPasswordRoute, resetPasswordRoute];

export default [
    dashboardsRoutes,
    insuranceCompaniesRoutes,
    policiesRoutes,
    plansRoutes,
    reportRoutes,
    settingsRoute
];
